const osiData = [
    { key: "application", name: "응용 계층(7계층)", description: "데이터 생성 및 전송 \n 사용자와 네트워크 간의 인터페이스 제공", protocols:["HTTP", "DHCP","Telnet", "FTP"], },
    { key: "presentation", name: "표현 계층(6계층)", description: "데이터 형식 변환 및 암호화",protocols: ["ASCII", "JPEG", "MPEG"], },
    { key: "session", name: "세션 계층(5계층)", description: "데이터 교환을 위한 논리적 연결을 \n설정, 관리, 종료 진행 \n\ 즉, 세션 관리", protocols: ["SSH", "TLS", "RPC"], },
    { key: "transport", name: "전송 계층(4계층)", description: "데이터의 전송을 신뢰성 있고 효율적으로 관리",protocols: ["TCP", "UDP"] },
    { key: "network", name: "네트워크 계층(3계층)", description: "라우팅 및 IP 주소 관리 \n 즉, 데이터 경로 설정과 라우팅 수행",protocols: ["IP", "ICMP"] },
    { key: "dataLink", name: "데이터링크계층(2계층)", description: "프레임 생성,\n 제어노드 간 데이터 전송과 에러 감지를 담당", protocols: ["Ethernet", "PPP"], },
    { key: "physical", name: "물리 계층(1계층)", description: "비트 전송과 물리적 연결을 담당", protocols: ["RS-232", "RS-485", "1000BASE-T"], },
  ];
  
  
  export const osiLayerInfo = {
    application: {
      name: "응용 계층",
      description: "사용자와 네트워크 간의 인터페이스를 제공하며, 데이터 생성 및 전송을 담당합니다.",
      protocols: ["HTTP", "SMTP", "FTP"],
    },
    presentation: {
      name: "표현 계층",
      description: "데이터 형식 변환 및 암호화를 담당합니다.",
      protocols: ["SSL", "TLS"],
    },
    session: {
      name: "세션 계층",
      description: "데이터 교환을 위한 논리적 연결을 설정, 관리, 종료합니다.",
      protocols: ["NetBIOS", "PPTP"],
    },
    transport: {
      name: "전송 계층",
      description: "데이터의 전송을 신뢰성 있고 효율적으로 관리합니다.",
      protocols: ["TCP", "UDP"],
    },
    network: {
      name: "네트워크 계층",
      description: "데이터의 경로를 설정하고 라우팅을 수행합니다.",
      protocols: ["IP", "ICMP"],
    },
    dataLink: {
      name: "데이터링크 계층",
      description: "노드 간 데이터 전송과 에러 감지를 담당합니다.",
      protocols: ["Ethernet", "PPP"],
    },
    physical: {
      name: "물리 계층",
      description: "비트 전송과 물리적 연결을 담당합니다.",
      protocols: ["Wi-Fi", "Bluetooth"],
    },
  };  

  export default osiData;
  